const STOCK_FALLBACK_TEXT = theme.strings.stockInfoFallbackTextHtml;
const STOCK_AVAILABLE_TEXT = theme.strings.stockInfoAvailableText;
const STOCK_EXTERNAL_WAREHOUSE_TEXT = theme.strings.stockInfoExternalWarehouseTextHtml;
const STOCK_SAME_DAY_CUTOFF_TEXT = theme.strings.stockInfoSameDayCutoffHtml;
const STOCK_OBSERVER_DATA_KEY = 'stockObserverAttached';
const STOCK_GRID_WITH_SAME_DAY_INFO_CLASS = 'ProductForm__InventoryGrid--withSameDayInfo';

let currentVariantHas48HAvailability = false;
let currentVariantHasTrackedInventory = false;
let currentVariantInventory = null;
let currentVariantStockMode = 'fallback';
let productInventories = {};

function is48HVariant(variant) {
  return Boolean(variant?.title?.includes('48H'));
}

function getVariantInventory(variant) {
  if (!variant?.id) {
    return null;
  }

  return productInventories[String(variant.id)] || {
    inventory_management: variant.inventory_management,
    inventory_policy: variant.inventory_policy,
    inventory_quantity: variant.inventory_quantity
  };
}

function hasTrackedInventory(variant) {
  const inventory = getVariantInventory(variant);

  return inventory?.inventory_management === 'shopify' && Number(inventory?.inventory_quantity) > 0;
}

function getInventoryStatus() {
  const stockCounts = Array.from(document.querySelectorAll('#inventoryLocationInformation .stockCount'));
  const hasStockCount = stockCounts.some((count) => parseInt(count.textContent.trim(), 10) > 0);
  const hasLocationList = document.querySelector('#inventoryLocationInformation #tomit_inventory_list');
  return {
    hasStockCount,
    hasLocationList: Boolean(hasLocationList)
  };
}

function setInventoryStatusText(text) {
  const block = document.getElementById('inventoryOutDesc');
  if (!block) {
    return;
  }

  block.innerHTML = text;
}

function setSameDayCutoffText(showSameDayInfo) {
  const note = document.getElementById('inventorySameDayInfo');
  const grid = document.getElementById('inventoryAvailabilityGrid');

  if (!note || !grid) {
    return;
  }

  note.innerHTML = STOCK_SAME_DAY_CUTOFF_TEXT;
  note.hidden = !showSameDayInfo;
  grid.classList.toggle(STOCK_GRID_WITH_SAME_DAY_INFO_CLASS, showSameDayInfo);
}

function setInventoryLocationVisibility(showLocations) {
  const container = document.getElementById('inventoryLocationInformation');
  if (!container) {
    return;
  }

  container.hidden = !showLocations;
}

function syncInventoryInfo(hasStockInfo) {
  const show48HAvailability = currentVariantHas48HAvailability && hasStockInfo;
  const showExternalWarehouseAvailability = !currentVariantHas48HAvailability && currentVariantHasTrackedInventory;

  if (show48HAvailability) {
    currentVariantStockMode = '48H';
    setInventoryStatusText(STOCK_AVAILABLE_TEXT);
    setSameDayCutoffText(true);
    setInventoryLocationVisibility(true);
    return;
  }

  if (showExternalWarehouseAvailability) {
    currentVariantStockMode = '72H✅';
    setInventoryStatusText(STOCK_EXTERNAL_WAREHOUSE_TEXT);
    setSameDayCutoffText(false);
    setInventoryLocationVisibility(false);
    return;
  }

  currentVariantStockMode = 'fallback';
  setInventoryStatusText(STOCK_FALLBACK_TEXT);
  setSameDayCutoffText(show48HAvailability);
  setInventoryLocationVisibility(currentVariantHas48HAvailability);
}

function maybeUpdateInventoryStatus() {
  const status = getInventoryStatus();
  syncInventoryInfo(status.hasStockCount || status.hasLocationList);
}

function ensureInventoryObserver() {
  const container = document.getElementById('inventoryLocationInformation');
  if (!container || container.dataset[STOCK_OBSERVER_DATA_KEY]) {
    return;
  }

  container.dataset[STOCK_OBSERVER_DATA_KEY] = 'true';

  const observer = new MutationObserver(() => {
    maybeUpdateInventoryStatus();
  });

  observer.observe(container, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

function logStockInfo(variant) {
  console.log('[stock-info]', {
    variantId: variant?.id || null,
    variantTitle: variant?.title || null,
    inventoryManagement: currentVariantInventory?.inventory_management ?? null,
    inventoryQuantity: currentVariantInventory?.inventory_quantity ?? null,
    is48H: currentVariantHas48HAvailability,
    hasTrackedInventory: currentVariantHasTrackedInventory,
    mode: currentVariantStockMode
  });
}

function renderStockInfo(newVariant) {
  currentVariantHas48HAvailability = is48HVariant(newVariant);
  currentVariantInventory = getVariantInventory(newVariant);
  currentVariantHasTrackedInventory = hasTrackedInventory(newVariant);

  if (!currentVariantHas48HAvailability) {
    syncInventoryInfo(false);
    logStockInfo(newVariant);
    ensureInventoryObserver();
    return;
  }

  syncInventoryInfo(false);
  ensureInventoryObserver();
  maybeUpdateInventoryStatus();
  logStockInfo(newVariant);

  const menuList = Array.from(document.querySelectorAll('#js-menu-list > li'));
  const blockToRender = document.getElementById('quantity-list-block');
  if (!blockToRender) {
    return;
  }

  blockToRender.innerHTML = '';
  const products = menuList.map(item => {
    const locationName = item.querySelector('.flyout-selection-container #location-name').textContent;
    const availability = item
      .querySelector('.metastock-flyout-location-availability-container .metastock-flyout-location-availability')
      .textContent
      .trim();
    return {
      locationName,
      availability: availability.includes('available')
        ? availability.replace('available', theme.strings.stockInfoPcsAbbrev)
        : theme.strings.stockInfoNone,
      isOutOfStock: availability.includes('Out of Stock')
    };
  });

  products.sort((a, b) => a.isOutOfStock - b.isOutOfStock);
  products.forEach(product => {
    const newParagraph = document.createElement('p');
    newParagraph.textContent = `${product.locationName} - ${product.availability}`;
    newParagraph.classList.add(product.isOutOfStock ? 'out-of-stock' : 'available-stock');
    blockToRender.appendChild(newParagraph);
  });
}

function initializeStockInfo() {
  const productJsonElement = document.querySelector('[data-product-json]');

  if (productJsonElement) {
    try {
      const productData = JSON.parse(productJsonElement.textContent);
      productInventories = productData?.inventories || {};
      const urlParams = new URLSearchParams(window.location.search);
      const urlVariantId = urlParams.get('variant');
      const selectedVariantId = urlVariantId || (productData?.selected_variant_id ? String(productData.selected_variant_id) : null);
      const selectedVariant = productData?.product?.variants?.find(
        (variant) => selectedVariantId && String(variant.id) === selectedVariantId
      );

      if (urlVariantId && selectedVariant?.title) {
        const variantTitleParts = selectedVariant.title.split(' / ').map((value) => value.trim());
        const variantOptionSelects = document.querySelectorAll('select[id^="options-variant_picker-"]');

        variantOptionSelects.forEach((select) => {
          const matchingOption = Array.from(select.options).find((option) =>
            variantTitleParts.includes(option.value)
          );

          if (matchingOption && select.value !== matchingOption.value) {
            select.value = matchingOption.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      renderStockInfo(selectedVariant);
    } catch (error) {
      console.error(error);
      renderStockInfo();
    }
  } else {
    renderStockInfo();
  }
}

document.addEventListener('variant:changed', (event) => {
  renderStockInfo(event?.detail?.variant);
});

initializeStockInfo();

window.renderStockInfo = renderStockInfo;
